var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tooltip",staticClass:"tooltip left"},[_c('div',{staticClass:"text w-full"},[_vm._t("default")],2),(!_vm.disabled)?_c('span',{staticClass:"tooltiptext"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }